var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-12 module-title" }, [
        _vm._v("INPAKKEN")
      ]),
      _vm._v(" "),
      !_vm.barcode && !_vm.packingSlip && !_vm.error
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info" }, [
              _vm._v(
                "\n        Scan een barcode van een pakbon om deze in te pakken.\n      "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.debug
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info error" }, [
              _vm._v("\n        " + _vm._s(_vm.debug) + "\n      ")
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.barcode && !_vm.packingSlip && !_vm.error
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info" }, [
              _c("span", { staticClass: "item-loader float-left" }),
              _vm._v(
                " Ophalen informatie " + _vm._s(_vm.barcode) + "...\n      "
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.barcode && _vm.packingSlip && !_vm.error
        ? _c(
            "div",
            { staticClass: "col-lg-12" },
            [
              _c("div", { staticClass: "product-info" }, [
                _c("table", [
                  _c("tr", [
                    _c("th", [_vm._v("Status")]),
                    _vm._v(" "),
                    _c("td", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.getPickingStatusBadge(
                            _vm.packingSlip.pickingStatus
                          )
                        )
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("Barcode")]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.packingSlip.barcode))])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", [_vm._v("Ingepakt")]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        _vm._s(_vm.numPicked) +
                          " / " +
                          _vm._s(_vm.packingSlip.items.length)
                      )
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _vm._l(_vm.packingSlip.items, function(item) {
                return _c("div", { staticClass: "product-info" }, [
                  _c("div", { staticClass: "product-info-cols" }, [
                    _c("div", { staticClass: "product-info-first-col" }, [
                      item.productionReceipt.localReceiptInfo
                        ? _c(
                            "span",
                            {
                              staticClass: "sequence-number",
                              class: _vm.getPickingStatusSequenceColorClass(
                                item.packingStatus
                              )
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  item.productionReceipt.localReceiptInfo
                                    .sequenceNumber
                                )
                              )
                            ]
                          )
                        : _c("span", {
                            staticClass: "sequence-number",
                            class: _vm.getPickingStatusSequenceColorClass(
                              item.packingStatus
                            )
                          }),
                      _vm._v(" "),
                      _c("span", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.getPackingStatusBadge(item.packingStatus)
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "barcode" }, [
                        _vm._v(_vm._s(item.productionReceipt.barcode))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "product-info-second-col" }, [
                      _c("span", {
                        staticClass: "product-info-item-badge",
                        domProps: {
                          innerHTML: _vm._s(_vm.getProductionStatusBadge(item))
                        }
                      }),
                      _c("br"),
                      _vm._v(" "),
                      _c("table", [
                        _c("tr", [
                          _c("td", { attrs: { colspan: "2" } }, [
                            _vm._v(
                              _vm._s(item.product.productName) +
                                " " +
                                _vm._s(item.variation.variationName)
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", [_vm._v("Productie:")]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("moment")(
                                  item.productionDate,
                                  "DD-MM-YYYY"
                                )
                              )
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("tr", [
                          _c("td", [_vm._v("Aflevering:")]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(
                              _vm._s(
                                _vm._f("moment")(
                                  item.deliveryDate,
                                  "DD-MM-YYYY"
                                )
                              )
                            )
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.barcode && !_vm.packingSlip && _vm.error
        ? _c("div", { staticClass: "col-lg-12" }, [
            _c("div", { staticClass: "product-info error" }, [
              _vm._v("\n        " + _vm._s(_vm.error) + "\n      ")
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b9329428", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b9329428","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ScanPacking.vue
// module id = 1Ymb
// module chunks = 1